import { memo } from 'react';
import { has, noop } from 'lodash';
// Import Types
import type { RouteModel } from 'types';
// Import UI Components
import { Breadcrumb } from '@geneui/components';
// Import Hooks
import useGoToRoute from 'hooks/GoToRoute';
import useQueryParams from 'hooks/UseQueryParams';

interface BreadcrumbItem {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    key: any;
    title: string;
    routeTo?: RouteModel;
}

interface Props {
    items?: BreadcrumbItem[];
    onClick?: (item: BreadcrumbItem) => void;
}

const StatefulBreadcrumb: React.FC<Props> = ({ items = [], onClick = noop, ...rest }) => {
    const { goToRoute } = useGoToRoute();
    const goToRouteQueryParams = useQueryParams();

    const onClickHandler = (item) => {
        if (has(item, 'routeTo')) {
            const decodedQueryParams = goToRouteQueryParams.decode();
            goToRoute(item.routeTo, null, decodedQueryParams.backParams);
        } else {
            onClick?.(item);
        }
    };

    return <Breadcrumb onClick={onClickHandler} data={items} {...rest} />;
};

export default memo(StatefulBreadcrumb);
